import ReactDOM from 'react-dom';
import ownerDocument from 'dom-helpers/ownerDocument';

export default function (componentOrElement) {
  // eslint-disable-next-line react/no-find-dom-node
  return ownerDocument(ReactDOM.findDOMNode(componentOrElement));
}
